
import React from 'react'
import ReactDOM from 'react-dom/client'

import './styles/variables.css'
import './styles/theme_dark.scss'
import './styles/theme_eagle.scss'
import './styles/theme_light.scss'
import './styles/main.scss'
import './styles/AdvancedReportItem.scss'

import App from './App'
import ErrorBoundary from "./shared/ErrorBoundary";
import reportWebVitals from './reportWebVitals'
import 'bootstrap/dist/css/bootstrap.min.css'

// <React.StrictMode><App /></React.StrictMode>

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
